/* Order bump "del Starter al Protocolo Firmeza" — pregunta PURA sobre la PDP.

   14n (diseño de Mau, 2026-08-24): el AÑADIR A LA CESTA del Starter se
   RETIENE. Este pop-up ya no toca la cesta, no hace swaps, no abre ni
   cierra el drawer: solo pregunta y responde. Quien decide qué comprar es
   js-main-product-protocolo (ejecutarCompra), con su única pipeline:

     ATC del Starter → skdupPreguntar({siAceptar, siRechazar})
       · ACTUALIZAR → siAceptar() → el ATC añade el PROTOCOLO
       · X / overlay / ESC / "No, continúo" → siRechazar() → añade el STARTER

   Así no existe nunca un carrito intermedio que arreglar (la clase de
   bugs de los estados mixtos muere por construcción). El pop-up se
   ofrece UNA vez por sesión; si ya se ofreció, no está en el DOM o algo
   falla, responde siRechazar() al instante: NUNCA se bloquea una venta.

   El botón de pagar es territorio de js-priority-plus y de
   js-cart-descuento: este archivo no lo toca. */
(function () {
  'use strict';

  var FOCUSABLE =
    'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';
  var SESSION_KEY = 'skdupOffered';

  var offeredMemory = false;

  function wasOffered() {
    if (offeredMemory) return true;
    try {
      return window.sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markOffered() {
    offeredMemory = true;
    try {
      window.sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {
      /* offeredMemory ya cubre esta carga de página */
    }
  }

  function initPopup(root) {
    if (!root || root.dataset.skdupInit === '1') return;
    root.dataset.skdupInit = '1';

    var overlay = root.querySelector('[data-skdup-overlay]');
    var dialog = root.querySelector('[data-skdup-dialog]');
    var closeBtn = root.querySelector('[data-skdup-close]');
    var acceptBtn = root.querySelector('[data-skdup-accept]');
    var declineBtn = root.querySelector('[data-skdup-decline]');

    if (!dialog || !acceptBtn) return;

    var lastFocused = null;
    var keydownHandler = null;
    /* Callbacks de la pregunta en curso (los fija skdupOpen). */
    var alAceptar = null;
    var alRechazar = null;
    var decidido = false;

    function responder(aceptado) {
      if (decidido) return; /* una decisión por apertura */
      decidido = true;
      var fn = aceptado ? alAceptar : alRechazar;
      alAceptar = null;
      alRechazar = null;
      close();
      if (typeof fn === 'function') {
        try { fn(); } catch (e) { /* la compra no puede tumbar el diálogo */ }
      }
    }

    function open(trigger, callbacks) {
      lastFocused = trigger || document.activeElement;
      alAceptar = callbacks && callbacks.siAceptar;
      alRechazar = callbacks && callbacks.siRechazar;
      decidido = false;
      root.removeAttribute('hidden');
      document.documentElement.style.overflow = 'hidden';
      /* La burbuja de Chatwoot se aparta mientras el pop-up está abierto
         (CSS en snippets/chatwoot-widget.liquid). */
      document.documentElement.classList.add('pdp-modal-open');

      try {
        dialog.focus();
      } catch (e) {
        /* focus best-effort */
      }

      keydownHandler = function (e) {
        if (e.key === 'Escape') {
          responder(false);
          return;
        }
        if (e.key !== 'Tab') return;
        var focusables = dialog.querySelectorAll(FOCUSABLE);
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      };
      document.addEventListener('keydown', keydownHandler, true);
    }

    function close() {
      root.setAttribute('hidden', 'hidden');
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('pdp-modal-open');
      if (keydownHandler) {
        document.removeEventListener('keydown', keydownHandler, true);
        keydownHandler = null;
      }
      if (lastFocused && lastFocused.focus) {
        try {
          lastFocused.focus();
        } catch (e) {
          /* el botón puede haber desaparecido con un repintado */
        }
      }
    }

    root.skdupOpen = open;

    if (closeBtn) closeBtn.addEventListener('click', function () { responder(false); });
    if (overlay) overlay.addEventListener('click', function () { responder(false); });
    if (declineBtn) declineBtn.addEventListener('click', function () { responder(false); });
    acceptBtn.addEventListener('click', function () { responder(true); });
  }

  /* Punto de entrada público. SIEMPRE responde: con pop-up (la decisión
     de la clienta) o sin él (siRechazar inmediato = añadir el Starter). */
  window.skdupPreguntar = function (callbacks) {
    var rechazar = callbacks && typeof callbacks.siRechazar === 'function'
      ? callbacks.siRechazar
      : function () {};

    if (wasOffered()) return rechazar();

    var root = document.querySelector('[data-skdup-popup]');
    if (!root || typeof root.skdupOpen !== 'function') return rechazar();

    markOffered();
    root.skdupOpen(null, callbacks);
  };

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-skdup-popup]'), initPopup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target || document;
    if (target.querySelectorAll) {
      Array.prototype.forEach.call(target.querySelectorAll('[data-skdup-popup]'), initPopup);
    }
  });
})();
